<template>
  <div class="media-recorder">
    <div class="flex flex-col w-full space-y-2">
      <video ref="videoRec" class="media-recorder__video" controls autoplay />
      <div class="flex justify-between xs:flex-col xs:space-x-0 xs:space-y-2 space-x-2">
        <Button
          v-show="videoStatus === 'none'"
          :disabled="disabledRecord"
          class="w-full"
          @click="startRecord"
        >
          <div class="flex space-x-1">
            <img src="@/assets/icons/play.svg" alt="">
            <span>{{ $t('video_interview.start-recording') }}</span>
          </div>
        </Button>
        <Button
          v-show="videoStatus === 'started'"
          palette="danger-400"
          class="w-full"
          @click="stopRecord"
        >
          <div class="flex space-x-1">
            <img src="@/assets/icons/stop.svg" alt="">
            <span>{{ $t('video_interview.stop-recording') }}</span>
          </div>
        </Button>
        <Button
          v-show="videoStatus === 'finished'"
          palette="neutral-200"
          @click="rewriteRecord"
        >
          <div class="flex space-x-1">
            <img src="@/assets/icons/play-primary.svg" alt="">
            <span>{{ $t('video_interview.re-record') }}</span>
          </div>
        </Button>
        <Button
          v-show="videoStatus === 'finished'"
          @click="finishRecord"
        >
          {{ $t('common.continue') }}
        </Button>
        <Button
          v-show="videoStatus !== 'finished' && !withoutSkip"
          palette="neutral-200"
          @click="$emit('finish-video-record')"
        >
        {{ $t('common.skip') }}
        </Button>
      </div>
    </div>
  </div>
</template>
<script>
import Button from '@/components/UI/Button.vue';
import toast from '@/notify';

export default {
  name: 'MediaRecorder',
  components: {
    Button,
  },
  props: {
    withoutSkip: {
      type: Boolean,
      default: false,
    },
    disabledRecord: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errText: null,
      isValid: true,
      isRecording: false, // recording mode identifier
      isFinished: false, // finished recording - action buttons indicator
      recorder: null, // component wide MediaRecorder
      connection: null, // component wide WebSocket
      videoUrl: null, // link to video - assigned when done writing video file
      video: null,
      stream: null,
      videoStatus: 'none', // started || finished
    };
  },
  mounted() {
    this.resetVideo();
  },
  methods: {
    // reset video display with media device media stream
    resetVideo() {
      this.isFinished = false;
      this.isRecording = false;
      this.isLoading = true;
      this.$refs.videoRec.muted = true;
      navigator.mediaDevices
        .getUserMedia({ audio: true, video: { facingMode: 'user' } })
        .then(this.gotStream)
        .catch(() => {
          toast.danger({
            text: this.$t('video_interview.turn-on-the-camera'),
          });
          this.isValid = false;
        });
    },
    // initialize MediaRecorder and video element source
    gotStream(mediaStream) {
      this.stream = mediaStream;
      this.recorder = new MediaRecorder(mediaStream, {
        mimeType: 'video/webm',
      });
      this.recorder.ondataavailable = this.videoDataHandler;
      this.$refs.videoRec.src = null;
      this.$refs.videoRec.srcObject = mediaStream;
      this.toggleVideo();
    },
    // handle sending data for writing using the given WebSocket
    videoDataHandler(event) {
      this.toggleVideo();
      this.$refs.videoRec.srcObject = null;
      this.$refs.videoRec.src = URL.createObjectURL(event.data);
      this.video = event.data;
      this.isUploading = false;
    },
    // toggle video display
    toggleVideo() {
      this.$refs.videoRec.loop = !this.$refs.videoRec.loop;
      this.$refs.videoRec.controls = !this.$refs.videoRec.controls;
    },
    // start record
    startRecord() {
      this.videoStatus = 'started';
      this.recorder.start();
      this.isRecording = true;
      this.$emit('record-started');
    },
    rewriteRecord() {
      this.$refs.videoRec.src = null;
      this.$refs.videoRec.srcObject = this.stream;
      this.toggleVideo();
      this.startRecord();
    },
    stopRecord() {
      this.recorder.stop();
      this.isRecording = false;
      this.isFinished = true;
      this.$refs.videoRec.muted = false;
      this.videoStatus = 'finished';
    },
    finishRecord() {
      this.$emit('finish-video-record', this.video);
      this.videoStatus = 'none';
      this.toggleVideo();
      this.$refs.videoRec.src = null;
      this.$refs.videoRec.srcObject = this.stream;
    },
  },
};
</script>
<style lang="scss"></style>
